enum ErrorDisplayTypeEnum {
  MODAL = 'modal',
  TOASTER = 'toaster',
  BANNER = 'banner',
}

enum ErrorManagerCodeEnum {
  ALL_ITEMS_NOT_AVAILABLE = 'all_items_not_available',
  SOME_ITEMS_NOT_AVAILABLE = 'some_items_not_available',
  INVALID_PROMOTION_ID = 'invalid_promotion_id',
  ITEM_NOT_FOUND = 'dem_item_not_found',
  INVALID_BOOKING_NUMBER = 'duplicate_request',
  INVALID_BOOKING_DATE = 'invalid_booking_date',
  BOOKING_NOT_FOUND = 'booking_not_found',
  BOOKING_NOT_ELIGIBLE = 'booking_not_eligible',
  PREPAID_CLOSED = 'prepaid_closed',
  INVALID_MEMBERSHIP_NUMBER = 'invalid_membership_number',
  CARD_ALREADY_IN_USE = 'card_already_in_use',
  INVALID_CARD_STATUS = 'invalid_card_status',
  ACCOUNT_ALREADY_HAS_CARD = 'account_already_has_card',
  CUSTOMER_PROFILE_INCOMPLETE = 'customer_profile_incomplete',
  ACCOUNT_CREATION_FAILED = 'AADB2C90157',
  USER_CANCELED = 'AADB2C90091',
  ACCESS_DENIED = 'access_denied',
  LOGIN_ACCESS_DENIED = 'LOGIN_ACCESS_DENIED',
  JWT_EXPIRED = 'JWT_EXPIRED',
  GENERIC_LOGIN_ERROR = 'generic_login_error',
  NO_EXCURSION_MATCH = 'no_excursions_match',
  ACCESSIBLE_CABIN_UNAVAILABLE = 'accessible_cabin_unavailable',
}

enum NavigationTypeEnum {
  REDIRECT = 'REDIRECT',
  ROUTING = 'ROUTING',
}

export { ErrorDisplayTypeEnum, ErrorManagerCodeEnum, NavigationTypeEnum };
